import React from 'react'
import { Container, Typography, Button, Avatar, Box } from '@mui/material'
import { theme } from "../ui/theme"
import { useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import { passwordSchema } from '../validation/passwordSchema'
import { FormTextField } from '../controls'
import { makeRequest } from '../apis/makeRequest'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { changePassword } from '../apis/accountRequests'
import { useSelector, useDispatch } from 'react-redux'
import { notificationActions } from '../actions/notificationActions'

const styles = {
    paper: {
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: "black",
        color: "white"
    },
    submit: {
        margin: theme.spacing(2, 0, 2),
        color: "white",
        backgroundColor: "black",
        transition: "all 0.2s ease-in-out",
        '&:hover': {
          backgroundColor: "black",
          opacity: "0.8"
        },
    },
}

const fields = passwordSchema.describe().fields

export default function ChangePassword() {

    const dispatch = useDispatch()
    const { unique_name } = useSelector(state => state.account)

    const { control, register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(passwordSchema),
        reValidateMode: 'onBlur'
    })

    const onSubmit = data => {
        data.UserName = unique_name

        makeRequest(
            () => changePassword(data),
            (res) => {
                dispatch(notificationActions.showSuccess({ message: 'Se cambio correctamente la contraseña' }))
            },
            (err) => {
                dispatch(notificationActions.showError({ message: 'la contraseña es incorrecta' }))
            }
        )
    }

    return (
        <Container component='main' maxWidth='xs'>
            <div style={styles.paper}>
                <Avatar style={styles.avatar}>
                    <VpnKeyIcon />
                </Avatar>
                <Typography component='h1' variant='h5' textAlign="center"> Cambio de contraseña</Typography>
                <form style={styles.form} onSubmit={handleSubmit(onSubmit)}>
                    <input {...register('unique_name')} defaultValue={unique_name} type="hidden" />
                    <FormTextField style={{ width: "100%" }} name='OldPassword' type='password' margin="dense" size='small'
                        control={control} schema={fields.OldPassword} formErrors={errors.OldPassword}
                    />
                    <FormTextField style={{ width: "100%" }} name='NewPassword' type='password' margin="dense" size='small'
                        control={control} schema={fields.NewPassword} formErrors={errors.NewPassword}
                    />
                    <FormTextField style={{ width: "100%" }} name='passwordConfirm' type='password' margin="dense" size='small'
                        control={control} schema={fields.passwordConfirm} formErrors={errors.passwordConfirm}
                    />
                    <Typography variant='caption'>
                        Utiliza 6 caracteres como mínimo,incluyendo una letra mayúscula, minúscula y un carácter no alfanumérico.
                    </Typography>
                    <Button size='small' fullWidth sx={styles.submit} type="submit">actualizar contraseña</Button>
                </form>
            </div>
        </Container>
    )
}